export default class FixedBadge {
    constructor() {
        this.badge = document.querySelector(".js-fixed-badge");
        this.close = document.querySelector(".js-fixed-badge-close");
        this.footer = document.querySelector(".js-footer, .l-footer, footer");

        this.isClosed = false;
        this.isShown = false;

        if (!this.badge) return;

        this._bindEvents();
    }

    _bindEvents() {
        this.close?.addEventListener("click", () => {
            this.isClosed = true;
            this._hide();
        });

        this.badge.addEventListener("animationend", () => {
            this.isShown = true;
            this.badge.classList.add("-shown");
        });

        window.addEventListener("scroll", () => {
            this._checkFooter();
        });
    }

    _hide() {
        this.badge.classList.add("-hide");
    }

    _show() {
        if (this.isClosed) return;

        if (this.isShown) {
            this.badge.classList.add("-shown");
        }

        this.badge.classList.remove("-hide");
    }

    _checkFooter() {
        if (!this.footer || this.isClosed) return;

        const footerTop = this.footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (footerTop < windowHeight) {
            this._hide();
        } else {
            this._show();
        }
    }
}